import React, { forwardRef } from "react";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { getMaskedString } from "../utility/service/tool-service";

export const MaskedFormInput = forwardRef(function MaskedFormInput(
  {
    value,
    onChange,
    onBlur,
    name,
    type = "text",
    labelText,
    labelClass = "",
    disabled = false,
    placeholder = "",
    errorMessage = "",
    maskType = "",
    maskView = true,
    setMaskView = () => {},
    disabledMask = false,
    tipSmall = "",
    infoTooltip = "",
    wrapperClass = "",
    wrapperStyle = {},
    ...rest
  },ref ) {
  const displayValue = maskView ? (value ?? "") : getMaskedString(maskType, value ?? "");

  return (
    <div className={`custom-input relative ${wrapperClass}`} style={wrapperStyle}>
      {labelText && (
        <div className="form-label">
          <label htmlFor={name} className={`form-label ${labelClass}`}>
            {labelText}
          </label>
          {tipSmall && <small style={{ color: "gray" }}>{tipSmall}</small>}
          {infoTooltip && (
            <>
              <Tooltip target=".pi-info-circle" />
              <span>
                <i className="pi pi-info-circle ml-1" data-pr-tooltip={infoTooltip}></i>
              </span>
            </>
          )}
        </div>
      )}

      <input
        type={type}
        id={name}
        name={name}
        ref={ref} // ✅ 使用 forwardRef 接進來的 ref
        value={displayValue}
        onChange={(e) => {
          if (maskView) {
            onChange(e.target.value);
          }
        }}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        readOnly={!maskView}
        className={`p-inputtext p-component ${errorMessage ? "p-invalid" : ""}`}
        {...rest}
      />

      {errorMessage && <small className="p-error pt-1">{errorMessage}</small>}
       {/* {maskType && (
        <div className="absolute right-0" style={{ top: "28px" }}>
          <Button
            type="button"
            icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
            severity="secondary"
            text
            disabled={disabledMask}
            onClick={() => setMaskView(!maskView)}
          />
        </div>
      )} */}
    </div>
  );
});
